export type LxBxHParts = { l: string; b: string; h: string }

const EMPTY: LxBxHParts = { l: '', b: '', h: '' }

/** Split a stored dimensions string such as "1290 x 1200 x 2375mm" into L/B/H. */
export const parseLxBxH = (raw: unknown): LxBxHParts => {
  const s = String(raw ?? '').trim()
  if (!s) return { ...EMPTY }

  const cleaned = s.replace(/mm\s*$/i, '').trim()
  const parts = cleaned.split(/\s*[x×X]\s*/)
  return {
    l: parts[0]?.trim() ?? '',
    b: parts[1]?.trim() ?? '',
    h: parts[2]?.trim() ?? '',
  }
}

/** Join L/B/H into the stored format "L x B x Hmm". Empty when all parts are blank. */
export const formatLxBxH = (parts: LxBxHParts): string => {
  const l = parts.l.trim()
  const b = parts.b.trim()
  const h = parts.h.trim()
  if (!l && !b && !h) return ''
  return `${l} x ${b} x ${h}mm`
}

export const isFUnitCategoryCode = (code?: string | null): boolean =>
  !!code && /^F[1-5](-|$)/.test(code)
